import useTSILeg from "./useTSILeg";
const useTSICallingPoint = (legId, index) => {
  const tsiLeg = useTSILeg(legId);
  if (!tsiLeg || index === void 0 || index < 0 || index > tsiLeg.callingPoints.length - 1)
    return void 0;
  return tsiLeg.callingPoints[index];
};
var useTSICallingPoint_default = useTSICallingPoint;
export {
  useTSICallingPoint_default as default
};
